
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const EcosystemPage = lazy(() => import('../pages/ecosystem/page'));
const TechnologyPage = lazy(() => import('../pages/technology/page'));
const PartnersPage = lazy(() => import('../pages/partners/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const PlatformsPage = lazy(() => import('../pages/platforms/page'));
const DeveloperToolsPage = lazy(() => import('../pages/developer-tools/page'));
const EngineeringLabPage = lazy(() => import('../pages/engineering-lab/page'));
const AiDataInfrastructurePage = lazy(() => import('../pages/ai-data-infrastructure/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/ecosystem',
    element: <EcosystemPage />,
  },
  {
    path: '/technology',
    element: <TechnologyPage />,
  },
  {
    path: '/partners',
    element: <PartnersPage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/platforms',
    element: <PlatformsPage />,
  },
  {
    path: '/developer-tools',
    element: <DeveloperToolsPage />,
  },
  {
    path: '/engineering-lab',
    element: <EngineeringLabPage />,
  },
  {
    path: '/ai-data-infrastructure',
    element: <AiDataInfrastructurePage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
